module.exports = __webpack_public_path__ + "static/img/1.cdeb7e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/1.png
// module id = WwYN
// module chunks = 0